import { render, staticRenderFns } from "./Sell.vue?vue&type=template&id=2815857b&scoped=true&"
import script from "./Sell.vue?vue&type=script&lang=js&"
export * from "./Sell.vue?vue&type=script&lang=js&"
import style0 from "./Sell.vue?vue&type=style&index=0&id=2815857b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2815857b",
  null
  
)

export default component.exports